import { render, staticRenderFns } from "./SubscriptionDetailsPage.vue?vue&type=template&id=25ccabc6&scoped=true&lang=pug"
import script from "./SubscriptionDetailsPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetailsPage.vue?vue&type=style&index=0&id=25ccabc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccabc6",
  null
  
)

export default component.exports